import adminTable from '@store/adminTable/reducers';

import { roles } from '@Modules/Roles/configs/constants';

export default adminTable(roles);
